"use strict";

const intelligenceTypes = {
  general: {
    title: "Общие",
    value: "general",
    permission: null,
  },
  route: {
    title: "Маршрут",
    value: "route",
    permission: null,
  },
  messages: {
    title: "Сообщения",
    value: "messages",
    permission: null,
  },
  chart: {
    title: "График",
    value: "chart",
    permission: null,
  },
  player: {
    title: "Плеер маршрута",
    value: "player",
    permission: null,
  },
  videoPlayer: {
    title: "Плеер видео",
    value: "videoPlayer",
    permission: null,
  },
  analiseSignal: {
    title: "Консоль",
    value: "analiseSignal",
    permission: 12001,
  },
};

export { intelligenceTypes };
